import {type NavigationGuardNext, type RouteLocationNormalized} from "vue-router";
import {getProjectResolver} from "@domains/boards/resolvers";
import {BoardsNs} from "@shared/types";
import {HelpWidgetType} from "@shared/constants/common.constants";
import {getEstimationResolver} from "@domains/boards/resolvers/get-estimation.resolver.ts";

export const boardsRoutes = [
    {
        path: '/boards/:projectId',
        name: BoardsNs.BoardsRouteEnums.BOARDS,
        component: () => import('./views/boards.layout.vue'),
        // Opening a project lands on Chat — the same place the rail's Chat row goes.
        redirect: {name: BoardsNs.BoardsRouteEnums.APP_DETAILS},
        props: true,
        beforeEnter: [
            (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
                getProjectResolver(to, from, next);
            },
        ],
        children: [
            {
                path: 'chat',
                name: BoardsNs.BoardsRouteEnums.APP_DETAILS,
                component: () => import('./views/feature/feature-view.vue'),
                props: true,
                meta: {
                    helpWidget: HelpWidgetType.APPLICATIONDETAILS,
                }
            },
            {
                path: 'feature',
                name: BoardsNs.BoardsRouteEnums.FEATURE,
                component: () => import('./views/feature/feature-view.vue'),
                props: true,
                meta: {
                    helpWidget: HelpWidgetType.FEATURE,
                }
            },
            {
                path: 'feature/:featureId',
                name: BoardsNs.BoardsRouteEnums.FEATURE_SELECTED,
                component: () => import('./views/feature/feature-view.vue'),
                props: true,
            },
            {
                path: 'feature/page/:pageId',
                name: BoardsNs.BoardsRouteEnums.PAGE_SELECTED,
                component: () => import('./views/feature/feature-view.vue'),
                props: true,
            },
            {
                path: 'screen',
                name: BoardsNs.BoardsRouteEnums.SCREEN,
                component: () => import('./views/screen/screen-view.vue'),
                props: true,
                meta: {
                    helpWidget: HelpWidgetType.SCREEN,
                }
            },
            {
                /* A group or a picture — screen-entry.vue asks the id which. */
                path: 'screen/:screenId',
                name: BoardsNs.BoardsRouteEnums.SCREEN_SELECTED,
                component: () => import('./views/screen/screen-entry.vue'),
                props: true,
            },
            {
                path: 'sources/:documentKey?',
                name: BoardsNs.BoardsRouteEnums.SOURCES,
                component: () => import('./views/sources/sources-view.vue'),
                props: true,
            },
            {
                path: 'documents',
                redirect: { name: BoardsNs.BoardsRouteEnums.SOURCES },
            },
            {
                path: 'estimation/:groupId?',
                name: BoardsNs.BoardsRouteEnums.ESTIMATION,
                component: () => import('./views/estimation/estimation-view.vue'),
                props: true,
                meta: {
                    helpWidget: HelpWidgetType.ESTIMATION,
                },
                beforeEnter: [
                    (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
                        getEstimationResolver(to, from, next);
                    },
                ]
            },
        ],
    },
];
